import { ProductMode } from './types';
import { BrandFilterProduct } from 'src/services/apiInterfaces';

/**
 * Product-specific wiring for initializing Insights workflow tags from a
 * user brand preference. Add a new config entry (and extend BrandFilterProduct)
 * when another product gains persistent brand filtering.
 */
export interface BrandWorkflowFilterConfig {
  brandFilterProduct: BrandFilterProduct;
  brandType: string;
  initializedParam: string;
  productMode: ProductMode;
}

export const WIDGET_BRAND_WORKFLOW_FILTER_CONFIG: BrandWorkflowFilterConfig = {
  brandFilterProduct: 'solve-widget',
  brandType: 'solve-widget',
  initializedParam: 'widget_brand_filter_initialized',
  productMode: 'widget',
};
